export default __webpack_public_path__ + "static/media/Gambetta-Light.42bd64d0.woff";